import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalcMonthPipe } from './calc-month.pipe';
import { UtilitiesService } from '../../services/utilities.service';

@NgModule({
    imports: [ CommonModule ],
    exports: [ CalcMonthPipe ],
    declarations: [ CalcMonthPipe ],
    providers: [ UtilitiesService ],
})
export class CalcMonthPipeModule {}
